import React from "react";
        
export default function Header(){
    
    return(
        <div className="header-section">
            <h3>Contacts Manager</h3>
        </div>
    )
}